import React from "react";
import { connect } from "react-redux";
import { Field, change } from "redux-form";
import {
  uploadProfileImageAction,
  imageFileTooBigAction
} from "../../../redux/actions/profile.actions";
import ReactCrop from "react-image-crop";
import "./styles.scss";
import "react-image-crop/dist/ReactCrop.css";
import { Translate } from "react-localize-redux";
import ImageUploadWidget from "../../ImageUploadWidget";
import { DEFAULT_USER_IMAGE_URL } from "../../../app.config";
import PrivacyDropdown from "../PrivacyDropdown";

const MAX_FILE_SIZE = 2000000;

class ImageUploadForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUrl: DEFAULT_USER_IMAGE_URL,
      file: null,
      fileData: null,
      src: null,
      crop: {
        aspect: 1,
        width: 50,
        x: 0,
        y: 0
      }
    };

    this.handleChange = this.handleChange.bind(this);
  }

  checkFileSize = file => {
    return file.size <= MAX_FILE_SIZE;
  };

  handleChange(e) {
    console.log(e.target.files[0]);

    if (this.checkFileSize(e.target.files[0])) {
      this.setState({
        file: URL.createObjectURL(e.target.files[0]),
        fileData: e.target.files[0]
      });

      if (e.target.files && e.target.files.length > 0) {
        const reader = new FileReader();
        reader.addEventListener("load", () =>
          this.setState({ src: reader.result })
        );
        reader.readAsDataURL(e.target.files[0]);
      }
    } else {
      this.props.imageFileTooBigAction();
    }
  }

  onUploadSubmit = () => {
    fetch(this.state.croppedImageUrl)
      .then(res => res.blob())
      .then(blob => {
        console.log(blob);
        this.props.uploadImage(
          new File([blob], "test.jpg", {
            contentType: "image/jpeg"
          })
        );
      });
    this.setState({ croppedImageUrl: null, src: null });
  };

  onImageLoaded = (image, pixelCrop) => {
    this.imageRef = image;

    // Make the library regenerate aspect crops if loading new images.
    const { crop } = this.state;

    if (crop.aspect && crop.height && crop.width) {
      this.setState({
        crop: { ...crop, height: null }
      });
    } else {
      this.makeClientCrop(crop, pixelCrop);
    }
  };

  onCropComplete = (crop, pixelCrop) => {
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = crop => {
    this.setState({ crop });
  };

  getExistingImage(profileImages) {
    if (profileImages.length) {
      return profileImages[0].image;
    } else {
      return false;
    }
  }

  getImageUrl = profileImageUrl => {
    if (profileImageUrl && this.state.imageUrl === DEFAULT_USER_IMAGE_URL) {
      return profileImageUrl;
    }

    return this.state.imageUrl;
  };

  async makeClientCrop(crop, pixelCrop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        pixelCrop,
        "newFile.jpeg"
      );

      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, pixelCrop, fileName) {
    const canvas = document.createElement("canvas");
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        blob.name = fileName;
        window.URL.revokeObjectURL(this.fileUrl);
        this.fileUrl = window.URL.createObjectURL(blob);
        resolve(this.fileUrl);
      }, "image/jpeg");
    });
  }

  render() {
    const { profileImageUrl } = this.props;
    const { crop, croppedImageUrl, src } = this.state;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-12">
            {croppedImageUrl ? (
              <img
                className="img-responsive profile-img"
                src={croppedImageUrl}
              />
            ) : (
              <img
                className="img-responsive img-circle profile-img"
                src={this.getImageUrl(profileImageUrl)}
              />
            )}
          </div>

          <div className="col-12">
            {src && (
              <ReactCrop
                src={src}
                crop={crop}
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              />
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-8">
            <Field name="image_url" type="text" component="input" hidden />
            <ImageUploadWidget
              buttonMessage={<Translate id="editImageText" />}
              onUpload={values => {
                console.log("on upload", values);
                this.props.changeFieldValue("image_url", values.secure_url);
                this.setState({ imageUrl: values.secure_url });
              }}
            />
          </div>
          <div className="col-2">
            <PrivacyDropdown
              selectLabel="Privacy"
              selectName="photo_privacy"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  imageFileTooBigAction: () => dispatch(imageFileTooBigAction()),
  uploadImage: file => {
    dispatch(uploadProfileImageAction(file));
  },
  changeFieldValue: (field, value) => {
    dispatch(change("EditProfileForm", field, value));
  }
});

const mapStateToProps = state => ({
  profileImageUrl: state.profile.profile.image_url,
  profileImages: state.profile.profile.image
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImageUploadForm);



// WEBPACK FOOTER //
// ./src/components/forms/ImageUploadForm/ImageUploadForm.jsx